import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '../base/controls';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import { SMALL_DEVICE_WIDTH } from '../../utils/constants/constants';
import rlPromo from '../../assests/img/rl-promo.png';

interface Props {
    visible: boolean;
    isShareEnabled: boolean;
    onPromoVisibleChange: () => void;
    onTryDispatcherButton: () => void;
}

const Promo = (props: Props) => {
    const { t } = useTranslation();
    const { width } = useWindowDimensions();

    return (
        <>
            {!props.visible && (
                <Button
                    type="white"
                    onClick={() => props.onPromoVisibleChange()}
                    className="rl-promo-button"
                    style={{ top: props.isShareEnabled ? '110px' : '90px' }}
                >
                    {t('Promo.showPromo')}
                </Button>
            )}
            <Drawer
                width={width <= SMALL_DEVICE_WIDTH ? '100%' : width / 2}
                placement="right"
                mask={!props.isShareEnabled}
                visible={props.visible}
                onClose={() => props.onPromoVisibleChange()}
                destroyOnClose={true}
                closeIcon={null}
                extra={
                    width > SMALL_DEVICE_WIDTH && (
                        <Space>
                            <Button type="link" onClick={() => props.onPromoVisibleChange()}>
                                {t('Promo.hide')}
                            </Button>
                        </Space>
                    )
                }
            >
                <div className="rl-promo-content">
                    <img src={rlPromo} alt="Promo" />
                    <div className="rl-promo-content-title">{t('Promo.title')}</div>
                    <div className="rl-promo-content-subtitle">{t('Promo.subtitle')}</div>
                    <Button type="secondary" onClick={props.onTryDispatcherButton}>
                        {t('NavBar.tryDispatcher')}
                    </Button>
                </div>
            </Drawer>
        </>
    );
};

export default Promo;
